import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Orvane',
    description: 'Self-flying LiDAR drones that measure bridges, power lines, turbines and terrain to the centimetre and catch structural risks early.',
    placeholder: 'Orvane, autonomous LiDAR inspection systems.',
    url: getOrigin()
}
